export const ranking = [
  { rank: 1, title: "春日档古装剧番位风波", category: "影视剧集", heat: 9860, trend: "up" },
  { rank: 2, title: "音乐节门票开售秒空", category: "音乐现场", heat: 8720, trend: "up" },
  { rank: 3, title: "旅行真人秀剪辑争议", category: "综艺前线", heat: 7990, trend: "flat" },
  { rank: 4, title: "演唱会临时改档", category: "音乐现场", heat: 7410, trend: "up" },
  { rank: 5, title: "限定周边设计翻车", category: "品牌联名", heat: 6880, trend: "down" },
  { rank: 6, title: "短剧出海分账模式", category: "短剧出海", heat: 6320, trend: "up" },
  { rank: 7, title: "演员转型导演口碑分化", category: "影视剧集", heat: 5940, trend: "flat" },
  { rank: 8, title: "颁奖礼座位图玄学", category: "明星动态", heat: 5510, trend: "down" },
];